import { useQuery } from "@tanstack/react-query";
import { getProgramme } from "../api/programmesApi";
import { queryKeys } from "../lib/queryKeys";

export function useProgrammeDetail(id: string | undefined) {
  return useQuery({
    queryKey: queryKeys.programmes.detail(id ?? ""),
    queryFn: () => getProgramme(id as string),
    enabled: Boolean(id),
  });
}
